import { createContext } from 'react';

export interface SelectionContextProps<T = any> {
  register(model: T): void;
  unregister(model: T): void;
  toggle(model: T): void;
  selections: T[];
}

export const SelectionContext = createContext<SelectionContextProps>({
  register: () => undefined,
  unregister: () => undefined,
  toggle: () => undefined,
  selections: [],
});
